/**
 * acceptedFileTypes - Fonte única dos tipos de arquivo aceitos como anexo no chat
 *
 * Consumido pelo input de anexo (ChatInput), pelo drag & drop/paste (ChatBox →
 * useDragAndPaste) e pelo chat de equipe (TeamChatInput). Precisa espelhar a
 * lista do backend (TROIA-V3-BACKEND/src/utils/attachment-types.ts) — arquivo
 * aceito aqui e recusado lá vira erro 400 no envio.
 *
 * IMPORTANTE: extensões (.ofx, .ret, .rem, certificados...) são obrigatórias na
 * lista — o browser não mapeia essas extensões para um MIME type (File.type fica
 * vazio), então filtrar só por MIME as bloquearia tanto no seletor de arquivo
 * quanto no drag & drop.
 */

/** MIME types aceitos — usados quando o browser conhece o tipo do arquivo. */
export const CHAT_ACCEPTED_MIME_TYPES: string[] = [
  'image/*',
  'video/*',
  'audio/*',
  // Documentos Office/PDF
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.oasis.opendocument.spreadsheet',
  'application/vnd.oasis.opendocument.presentation',
  'application/rtf',
  'text/plain',
  'text/markdown',
  'text/x-markdown',
  'text/csv',
  'application/json',
  // Arquivos fiscais/contábeis
  'application/xml',
  'text/xml',
  'application/x-ofx',
  // Certificados digitais (A1 etc.)
  'application/x-pkcs12',
  'application/pkcs12',
  'application/x-x509-ca-cert',
  'application/x-pem-file',
  'application/pkcs7-mime',
  // Compactados
  'application/zip',
  'application/x-zip-compressed',
  'application/vnd.rar',
  'application/x-rar-compressed',
  'application/x-7z-compressed',
];

/** Extensões aceitas — cobrem arquivos sem MIME conhecido pelo browser. */
export const CHAT_ACCEPTED_EXTENSIONS: string[] = [
  '.pdf', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx',
  '.odt', '.ods', '.odp', '.rtf', '.txt', '.md', '.markdown', '.csv', '.json',
  '.xml', '.ofx', '.qif', '.ret', '.rem',
  '.pfx', '.p12', '.cer', '.crt', '.pem', '.p7b',
  '.zip', '.rar', '.7z',
];

/** Lista combinada para o useDragAndPaste (MIME types + extensões). */
export const CHAT_ACCEPTED_FILE_PATTERNS: string[] = [
  ...CHAT_ACCEPTED_MIME_TYPES,
  ...CHAT_ACCEPTED_EXTENSIONS,
];

/** Valor do atributo `accept` do input de arquivo (aceita MIME e extensão). */
export const CHAT_FILE_INPUT_ACCEPT = CHAT_ACCEPTED_FILE_PATTERNS.join(',');
